import { Routes } from '@constants/routes';

export const AepWizardStages = {
  Intro: {
    hrefs: [Routes.aepIntro],
    label: 'Intro',
  },
  Details: {
    hrefs: [Routes.aepPlans, Routes.aepZipCode, Routes.accountCallUs, Routes.aepUpdateAddress],
    label: 'Current Plan',
  },
  Providers: {
    hrefs: [Routes.aepProviders],
    label: 'Doctors',
  },
  Prescriptions: {
    hrefs: [Routes.aepPrescriptions],
    label: 'Prescriptions',
  },
  Pharmacies: {
    hrefs: [Routes.aepPharmacies],
    label: 'Pharmacies',
  },
  Recommendations: {
    hrefs: [Routes.aepRecommendations],
    label: 'Recommendations',
  },
};

export const pdpSteps = [
  AepWizardStages.Intro,
  AepWizardStages.Details,
  AepWizardStages.Prescriptions,
  AepWizardStages.Pharmacies,
  AepWizardStages.Recommendations,
];

export const mapdSteps = [
  AepWizardStages.Intro,
  AepWizardStages.Details,
  AepWizardStages.Providers,
  AepWizardStages.Prescriptions,
  AepWizardStages.Pharmacies,
  AepWizardStages.Recommendations,
];

export const maSteps = [
  AepWizardStages.Intro,
  AepWizardStages.Details,
  AepWizardStages.Providers,
  AepWizardStages.Recommendations,
];
